// This file contains all constant variables and env file variables

export const API_URL =   process.env.REACT_APP_API_URL;
